import { SET_USERPROFILE, CLEAR_USERPROFILE, EDIT_SUCCESS,  EDIT_FAIL } from "../action/types";

const initialState = {
  user: null,
  isClickAnotherProfile: false,
};

export default function userProfileReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_USERPROFILE:
      return { user: payload, isClickAnotherProfile: true };

    case CLEAR_USERPROFILE:
      return { ...state, user: null, isClickAnotherProfile: false };

    case EDIT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case EDIT_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    default:
      return state;
  }
}
